const ScreenTypes = [
	'BROWSE_ALL',
	'SEARCH_ALL',
	'SEARCH_PEOPLE',
	'SEARCH_TEAMS',
	'YOUR_TEAMS',
	'BROWSE_DEPARTMENTS',
	'BROWSE_LOCATIONS',
	'BROWSE_JOB_TITLES',
	'BROWSE_KUDOS',
	'BROWSE_AGENTS',
	'SEARCH_AGENTS',
] as const;

export type ScreenType = (typeof ScreenTypes)[number];

const DEFAULT_SCREEN_TYPE: ScreenType = 'BROWSE_ALL';

export const getScreenFromStringOrDefault = (screenKey: string | undefined): ScreenType =>
	screenKey && (ScreenTypes as readonly string[]).includes(screenKey)
		? (screenKey as ScreenType)
		: DEFAULT_SCREEN_TYPE;

export const TEAM_SEARCH_SCREEN_TYPES: ScreenType[] = ['SEARCH_TEAMS', 'YOUR_TEAMS'];
